var _defs, _rect, _g, _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgFlagCl = function SvgFlagCl(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-6{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:red;}.cls-4{fill:#fff;}.cls-5{fill:#361dff;}.cls-6{stroke:#fff;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.6,11.57A10.6,10.6,0,1,1,11.77,1.2H12A10.49,10.49,0,0,1,22.6,11.57Z"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 24,
    height: 24
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3575",
    "data-name": "Grupo 3575"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3574",
    "data-name": "Grupo 3574"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2264-2",
    "data-name": "Grupo 2264-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2008",
    "data-name": "Rect\\xE1ngulo 2008",
    className: "cls-3",
    x: 0.82,
    y: 11.51,
    width: 23.75,
    height: 11.18
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2009",
    "data-name": "Rect\\xE1ngulo 2009",
    className: "cls-4",
    x: 12,
    y: 0.33,
    width: 11.88,
    height: 11.18
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5607",
    "data-name": "Trazado 5607",
    className: "cls-5",
    d: "M.17.42H12.1V11.6H.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5608",
    "data-name": "Trazado 5608",
    className: "cls-4",
    d: "M8.46,7.05,7.87,5.24,7.29,7.05H5.39L6.92,8.17,6.34,10,7.87,8.86,9.41,10,8.82,8.17l1.54-1.12Z"
  })))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6874-2",
    "data-name": "Trazado 6874-2",
    className: "cls-6",
    d: "M22.6,11.57A10.6,10.6,0,1,1,11.77,1.2H12A10.49,10.49,0,0,1,22.6,11.57Z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFlagCl, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/FlagCl.71e1a56b.svg";
export { ForwardRef as ReactComponent };